import { ChevronRight } from "lucide-react";
import { ItemCard } from "./item-card";
import { DemonstrativoExtratoBancarioCardsProps } from "../../demonstrativo-extrato-bancario.types";
import React from "react";

export function DemonstrativoExtratoBancarioCards({ itensCard }: DemonstrativoExtratoBancarioCardsProps) {
  return (
    <div className="flex items-center justify-start gap-4">
      {itensCard.map((i, index) => (
        <React.Fragment key={index}>
          <ItemCard label={i.label} value={i.value} classes={i.classes} />
          {index < itensCard.length - 1 && (
            <ChevronRight className="w-4 h-4 text-secondary shrink-0" />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}